import { render, staticRenderFns } from "./FUrlBtn.vue?vue&type=template&id=5f368317&"
import script from "./FUrlBtn.vue?vue&type=script&lang=js&"
export * from "./FUrlBtn.vue?vue&type=script&lang=js&"
import style0 from "./FUrlBtn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports